/** Copyright (c) 2018, MOBICOOP. All rights reserved. This project is dual
licensed under AGPL and proprietary licence. This program is free software: you
can redistribute it and/or modify it under the terms of the GNU Affero General
Public License as published by the Free Software Foundation, either version 3 of
the License, or (at your option) any later version. This program is distributed
in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the
implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details. You should have received a
copy of the GNU Affero General Public License along with this program. If not,
see gnu.org/licenses. Licence MOBICOOP described in the file LICENSE
**************************/

<template>
  <div class="mc-form-register">
    <div class="mc-form-register-input">
      <ion-item>
        <ion-label
          >{{ $t("Register.birthDate") }}
          <span v-if="requiredBirthdate">*</span></ion-label
        >
        <ion-datetime-button
          slot="end"
          datetime="datePickerHitchHikingRegister"
        ></ion-datetime-button>
        <ion-modal :keep-contents-mounted="true">
          <ion-datetime
            display-format="DD/MM/YYYY"
            picker-format="DD/MM/YYYY"
            presentation="date"
            :show-default-buttons="true"
            :cancel-text="$t('Commons.cancel')"
            :done-text="$t('Commons.validate')"
            :value="user.birthDate"
            :max="now"
            :first-day-of-week="1"
            @ionChange="
              user.birthDate = $event.detail.value;
              checkBirthdate();
            "
            id="datePickerHitchHikingRegister"
          ></ion-datetime>
        </ion-modal>
      </ion-item>
      <div v-if="v$.user.birthDate && v$.user.birthDate.$error">
        <div class="mc-error-label" v-if="v$.user.birthDate.required.$invalid">
          {{ $t("Validation.required") }}
        </div>
        <div
          class="mc-error-label"
          v-if="v$.user.birthDate.isMaxBirthDate.$invalid"
        >
          {{ $t("Validation.age", { value: minAge }) }}
        </div>
      </div>

      <br />

      <ion-item
        v-on:click="
          goGeoSearch('complete_register_address_hitchhiking', 'search')
        "
      >
        <ion-label position="stacked"
          >{{ $t("HitchHiking.register.address") }} *</ion-label
        >
        <ion-input
          type="text"
          name="address"
          :value="displayAddress"
          readonly="true"
          class="no-clickable ellipsis"
          v-bind:placeholder="$t('HitchHiking.register.address')"
        ></ion-input>
      </ion-item>
      <div v-if="v$.user.addresses && v$.user.addresses.$error">
        <div class="mc-error-label" v-if="v$.user.addresses.required.$invalid">
          {{ $t("Validation.required") }}
        </div>
        <div
          class="mc-error-label"
          v-if="v$.user.addresses.fullAddress.$invalid"
        >
          {{ $t("HitchHiking.validation.fullAddress") }}
        </div>
      </div>

      <ion-item>
        <ion-label position="stacked"
          >{{ $t("HitchHiking.register.postalAddress") }}
        </ion-label>
        <ion-input
          type="text"
          name="address"
          :value="user.postalAddress"
          @input="changePostalAddress($event)"
          v-bind:placeholder="$t('HitchHiking.register.postalAddress')"
        ></ion-input>
      </ion-item>
      <div v-if="v$.user.postalAddress && v$.user.postalAddress.$error">
        <div
          class="mc-error-label"
          v-if="v$.user.postalAddress.required.$invalid"
        >
          {{ $t("Validation.required") }}
        </div>
      </div>
      <br />

      <div class="text-left" v-if="user.addresses && user.addresses[0]">
        <div>
          <small
            ><ion-label position="stacked">{{
              $t("HitchHiking.register.total-address")
            }}</ion-label></small
          >
        </div>
        <div>{{ user.givenName }} {{ user.familyName }}</div>
        <div>{{ user.postalAddress }}</div>
        <div>
          <div>
            {{ user.addresses[0].houseNumber }}
            {{ user.addresses[0].streetAddress }}
          </div>
          <div>
            {{ user.addresses[0].postalCode }}
            {{ user.addresses[0].addressLocality }}
          </div>
        </div>
      </div>
      <br />
      <ion-item lines="none">
        <ion-checkbox
          label-placement="end"
          name="newsSubscription"
          :value="user.newsSubscription"
          color="success"
          slot="start"
          @ionChange="changeNewsSubscription($event)"
          :checked="user.newsSubscription"
          ><span class="no-white-space">{{
            $t("Register.newsSubscription")
          }}</span></ion-checkbox
        >
      </ion-item>

      <br /><br />
      <div class="text-asterisk text-left">
        <small>* Champ obligatoire</small>
      </div>
    </div>
    <br />
  </div>
</template>

<style lang="scss">
.no-white-space {
  white-space: normal !important;
}
.mc-form-register {
  display: block;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;

  .mc-form-register-input {
    flex: 1;
    flex-direction: column;
    display: flex;
    justify-content: center;
  }
}

.text-asterisk {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}
</style>

<script>
import {
  required,
  email,
  sameAs,
  minLength,
  requiredIf,
} from "@vuelidate/validators";
import { nextTick } from "vue";
import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
var moment = require("moment");

const isMaxBirthDate = (value, vm) => {
  if (JSON.parse(process.env.VUE_APP_REQUIRED_BIRTHDATE)) {
    let n = new Date();
    n.setFullYear(n.getFullYear() - process.env.VUE_APP_REGISTER_MIN_AGE);
    return moment(value).isBefore(moment(n.toISOString()));
  } else {
    return true;
  }
};

export default {
  name: "hitchHiking.completeRegisterStep1",
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      instance: process.env.VUE_APP_INSTANCE,
      maxBirthDate: this.getMaxBirthDate(),
      minAge: process.env.VUE_APP_REGISTER_MIN_AGE,
      minorAge: 18,
      requiredBirthdate: JSON.parse(process.env.VUE_APP_REQUIRED_BIRTHDATE),
      parentalConsentActivated: JSON.parse(
        process.env.VUE_APP_PARENTAL_CONSENT
      ),
      showCommunities: JSON.parse(process.env.VUE_APP_REGISTER_COMMUNITY),
      neededCommunities: JSON.parse(
        process.env.VUE_APP_REGISTER_COMMUNITY_NEEDED
      ),
      genderRequired: JSON.parse(process.env.VUE_APP_GENDER_REQUIRED),
      fullAddressRequired: JSON.parse(
        process.env.VUE_APP_HITCHHIKING_REGISTER_FULL_ADDRESS
      ),
      communities: [],
      checkedPhoneNumber: null,
      now: new Date().toISOString(),
      indicatifs: JSON.parse(process.env.VUE_APP_PHONE_IND),
      needParentalConsent: false,
    };
  },
  validations() {
    return {
      user: {
        addresses: {
          required,
          fullAddress(address) {
            return this.fullAddressRequired
              ? address[0]
                ? address[0].type === "housenumber" ||
                  address[0].type === "street"
                : false
              : true;
          },
        },
        birthDate: {
          required: requiredIf(function () {
            return this.requiredBirthdate;
          }),
          isMaxBirthDate,
        },
      },
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.state.userStore.user;
      },
      set(user) {
        this.$store.commit("user_request_success", user);
      },
    },
    displayAddress: {
      get() {
        return (
          this.$store.state.userStore.user.addresses[0]?.displayLabel?.join(
            " "
          ) || ""
        );
      },
    },
  },
  created() {
    if (
      !!this.user &&
      !this.user.hitchHikeDriver &&
      !this.user.hitchHikePassenger
    ) {
      this.user.hitchHikeDriver = true;
    }
  },
  watch: {
    "user.addresses[0].displayLabel": {
      handler(newDisplayLabel) {
        if (newDisplayLabel && newDisplayLabel.length > 0) {
          this.user.postalAddress = newDisplayLabel.join(" ");
        }
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    getMaxBirthDate() {
      let n = new Date();
      n.setFullYear(n.getFullYear() - process.env.VUE_APP_REGISTER_MIN_AGE);
      return n.toISOString();
    },
    goGeoSearch(type, action) {
      this.$router.push({
        name: "geoSearch",
        query: { type, action, fullAddressRequired: this.fullAddressRequired },
      });
    },
    async validate() {
      await this.v$.$reset();
      await this.v$.$touch();
      if (this.v$.$invalid) {
        return false;
      } else {
        return true;
      }
    },
    changePostalAddress(event) {
      this.user.postalAddress = event.target.value;
    },
    checkBirthdate() {
      let minAge = new Date();
      minAge.setFullYear(minAge.getFullYear() - this.minAge);
      let legalAge = new Date();
      legalAge.setFullYear(legalAge.getFullYear() - this.minorAge);
      const res =
        moment(this.user.birthDate).isBefore(moment(minAge.toISOString())) &&
        moment(this.user.birthDate).isAfter(moment(legalAge.toISOString()));
      if (this.parentalConsentActivated && res) {
        this.needParentalConsent = true;
      } else {
        this.needParentalConsent = false;
      }
    },
    changeNewsSubscription(event) {
      event.detail.checked
        ? (this.user.newsSubscription = true)
        : (this.user.newsSubscription = false);
    },
  },
};
</script>
